import { RegisterForm } from "@/components/register-form";

export function RegisterPage() {
  return (
    <div className="container mx-auto flex h-screen items-center justify-center">
      <RegisterForm className="w-full max-w-md" />
    </div>
  );
}

export default RegisterPage;
